import React, { useState } from 'react';

import { ENV } from '@environment';
import GoogleMapReact from 'google-map-react';

import useStoreTranslation from 'hooks/useStoreTranslation';
import { TravelHotelContentLocationRequest } from 'models/hotelLocation';
import { HotelsResultResponse } from 'models/hotelsSearch';

import FloatingCard from './components/FloatingCard';
import Pin from './components/Pin';
import { MapBox } from './styles';
import { City } from 'models/city';

interface Props {
  show: boolean;
  currency: string;
  hotelsResult: HotelsResultResponse[];
  destinationPoint?: TravelHotelContentLocationRequest | City;
  onClick: (hotel: HotelsResultResponse) => void;
  onClose: () => void;
}

const DEFAULT_ZOOM_VALUE = 14;
const GOOGLE_MAPS_API_KEY = ENV.API_KEYS.GOOGLE_MAPS_API_KEY as string;

export const HotelsMap = ({ show, currency, hotelsResult, destinationPoint, onClick, onClose, ...props }: Props) => {
  const { t } = useStoreTranslation();
  const [selectedCard, setSelectedCard] = useState<HotelsResultResponse>();
  const [zoom, setZoom] = useState(DEFAULT_ZOOM_VALUE);
  const [showCard, setShowCard] = useState(false);

  const handlePinClick = (key: number) => {
    setSelectedCard(hotelsResult[key]);
    setShowCard(true);
  };

  const handleCardClick = () => {
    onClick(selectedCard as HotelsResultResponse);
    setShowCard(false);
  };

  const handleZoomChange = (value: number) => {
    setZoom(value);
  };

  const mapCenter = {
    lat: hotelsResult.length > 0 ? hotelsResult.first().latitude : 0,
    lng: hotelsResult.length > 0 ? hotelsResult.first().longitude : 0,
  };

  return (
    <MapBox isVisible={show}>
      {show ? (
        <>
          <GoogleMapReact
            bootstrapURLKeys={{
              key: GOOGLE_MAPS_API_KEY,
              language: t('locale').substring(0, 2),
              region: t('locale').substring(3),
              libraries: ['places'],
            }}
            defaultCenter={mapCenter}
            defaultZoom={DEFAULT_ZOOM_VALUE}
            yesIWantToUseGoogleMapApiInternals={true}
            options={{
              fullscreenControl: false,
              zoomControl: false,
              clickableIcons: false,
            }}
            onZoomAnimationEnd={handleZoomChange}
            onZoomAnimationStart={handleZoomChange}
          >
            {hotelsResult.map((hotel, index) => (
              <Pin
                key={index}
                data={hotel}
                itemCode={index}
                onSelect={handlePinClick}
                isSelected={selectedCard?.hotelCode === hotel.hotelCode}
                lat={hotel.latitude}
                lng={hotel.longitude}
                zoom={zoom}
              />
            ))}
          </GoogleMapReact>
          <FloatingCard data={selectedCard} show={showCard} onClick={handleCardClick} />
        </>
      ) : (
        ''
      )}
    </MapBox>
  );
};

export default HotelsMap;
